module.exports = __webpack_public_path__ + "img/icon-security-level.2be70202.svg";